import { Box, IconButton, Link, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CopyToClipboardButton from '@shared/components/others/CopyToClipboardButton/CopyToClipboardButton';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const TestrunJiraBugsTable = ({ jiraBugs, handleDeleteJiraBug, readonly }) => {
    const { t } = useTranslation();

    return (
        <Table
            sx={{
                '.MuiTableCell-head': {
                    fontWeight: 700,
                    fontSize: '0.875rem',
                },
            }}
        >
            <TableHead>
                <TableRow>
                    <TableCell size="small">{t('jira_link')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody sx={{ maxHeight: '10px', overflowY: 'auto' }}>
                {!jiraBugs.length && (
                    <TableRow sx={{ color: 'var(--text-disabled)', padding: '6px 16px', display: 'block' }}>
                        <td>{t('no_jira_bugs_added')}</td>
                    </TableRow>
                )}
                {jiraBugs.map((link) => (
                    <TableRow key={link} sx={{ '&:hover': { background: 'var(--primary-main-subtle)' } }}>
                        <TableCell size="small">
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Link
                                    underline="hover"
                                    href={link}
                                    target="_blank"
                                    sx={{ cursor: 'pointer', fontSize: '0.875rem' }}
                                >
                                    {link}
                                </Link>
                                {!readonly && (
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <CopyToClipboardButton textToCopy={link}>{link}</CopyToClipboardButton>
                                        <IconButton color="default" onClick={handleDeleteJiraBug(link)} size="small">
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TestrunJiraBugsTable;
